import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import DownloadableItem from '@/components/molecules/DownloadableItem.vue';
import ViewableItem from '@/components/molecules/ViewableItem.vue';
import downloadFile from '@/utils/downloadFile';
import { getExperienceDownload, getOwnExperienceDownload } from '@/services/Profile/Api';
import useProfileState from '@/state/profile/profileState';
import { computed } from 'vue';
import usePopupState from '@/state/usePopupState';
import useI18n from '@/mixins/useI18n';
import buildProfileProjectsPdfFilename from '@/views/profile/utils/profileProjectsFilename';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileProjectsView',
  setup(__props) {

const { setPdf, showPopup, hidePopup } = usePopupState();
const { locale } = useI18n();

const {
  user, profile, isSelf, userId
} = useProfileState();

const documentLabel = computed(() => profile.value?.experiences?.experiencesDocumentLabel ?? '');
const localDocument = computed(() => (
  isSelf.value ? profile.value?.experiences?.experiencesDocument ?? '' : ''
));
const text = computed(() => profile.value?.experiences?.experiencesText ?? '');

const getDownloadData = async () => (isSelf.value ? getOwnExperienceDownload() : getExperienceDownload(userId.value));

const pdfFilename = computed(() => buildProfileProjectsPdfFilename(
  locale.value,
  user.value?.firstname,
  user.value?.lastname
));

const download = async () => {
  if (documentLabel.value) {
    if (localDocument.value) {
      downloadFile(localDocument.value, pdfFilename.value, 'application/pdf');
      return;
    }

    const { attachment = '' } = await getDownloadData();
    if (attachment) {
      downloadFile(attachment, pdfFilename.value, 'application/pdf');
    }
  }
};

const view = async () => {
  if (documentLabel.value) {
    showPopup();

    try {
      if (localDocument.value) {
        setPdf(localDocument.value, pdfFilename.value);
        return;
      }

      const { attachment } = await getDownloadData();

      setPdf(attachment, pdfFilename.value);
    } catch (error) {
      hidePopup();
    }
  }
};


return { __sfc: true,setPdf, showPopup, hidePopup, locale, user, profile, isSelf, userId, documentLabel, localDocument, text, getDownloadData, pdfFilename, download, view, BCXMarkdown, DownloadableItem, ViewableItem }
}

})